import { useState } from 'react';
import styles from '../Styles/Services.module.css';
import Container from '../UI/Container';
import SectionTitle from '../UI/SectionTitle';

const icons = {
  security: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V7L12 2z"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 12l2 2 4-4"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  infrastructure: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <rect x="2" y="3" width="20" height="14" rx="2"
        stroke="currentColor" strokeWidth="1.5"/>
      <path d="M8 21H16M12 17V21"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  network: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M5 12H3M21 12h-2M12 5V3M12 21v-2"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M18.364 5.636l-1.414 1.414M7.05 16.95l-1.414 1.414M18.364 18.364l-1.414-1.414M7.05 7.05L5.636 5.636"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  electrical: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  maintenance: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
};

const servicesData = [
  {
    id: 1,
    icon: icons.security,
    title: 'Seguridad Electrónica',
    description: 'Protección integral con tecnología avanzada que garantiza la tranquilidad de su patrimonio y el cuidado de sus seres queridos siempre.',
    features: [
      { label: 'Cámaras de Seguridad',           tooltip: 'Instalación y configuración de cámaras IP y análogas con monitoreo remoto 24/7' },
      { label: 'Sistema de Detección de Incendio', tooltip: 'Sensores y alarmas que detectan humo y calor para una respuesta inmediata ante emergencias' },
      { label: 'Seguridad Perimetral',             tooltip: 'Protección del perímetro mediante sensores de movimiento, barreras infrarrojas y cercas eléctricas' },
      { label: 'Alarma Comunitaria',               tooltip: 'Sistema de alerta integrado que notifica a toda la comunidad ante cualquier incidente de seguridad' },
    ],
  },
  {
    id: 2,
    icon: icons.infrastructure,
    title: 'Infraestructura Tecnológica',
    description: 'Equipamos tu espacio de trabajo con la tecnología que tu equipo merece, para que cada día sea más productivo y eficiente.',
    features: [
      { label: 'Venta de equipos',       tooltip: 'Computadores, laptops y servidores de alto rendimiento con garantía y soporte incluido' },
      { label: 'Componentes especializados', tooltip: 'Upgrades de SSD, RAM y GPU para maximizar el rendimiento de tus equipos actuales' },
      { label: 'Instalación',            tooltip: 'Configuración profesional de equipos y software lista para usar desde el primer día' },
      { label: 'Asesoría técnica',       tooltip: 'Orientación experta para elegir la solución tecnológica más adecuada a tu presupuesto y necesidades' },
    ],
  },
  {
    id: 3,
    icon: icons.network,
    title: 'Redes y Conectividad',
    description: 'Conectamos tu empresa al mundo con redes estables y seguras que nunca te dejan sin señal cuando más lo necesitas.',
    features: [
      { label: 'Instalación de redes',   tooltip: 'Diseño e implementación de redes LAN y WLAN adaptadas a la estructura de tu espacio' },
      { label: 'Cableado estructurado',  tooltip: 'Instalación ordenada de cableado UTP, fibra óptica y coaxial para máxima eficiencia' },
      { label: 'Configuración',          tooltip: 'Ajuste y optimización de routers, switches y puntos de acceso para una conectividad óptima' },
      { label: 'Solución de fallas',     tooltip: 'Diagnóstico y reparación rápida de interrupciones en tu red para minimizar el tiempo de inactividad' },
    ],
  },
  {
    id: 4,
    icon: icons.electrical,
    title: 'Sistemas Eléctricos',
    description: 'Tu tranquilidad empieza por una instalación eléctrica segura. Protegemos tu hogar y negocio desde los cimientos.',
    features: [
      { label: 'Instalaciones eléctricas', tooltip: 'Diseño y ejecución de instalaciones residenciales y comerciales bajo normas técnicas vigentes' },
      { label: 'Mantenimiento',            tooltip: 'Revisiones periódicas para prevenir fallos, cortocircuitos y riesgos eléctricos' },
      { label: 'Diagnóstico',              tooltip: 'Inspección técnica para identificar fallas ocultas antes de que se conviertan en problemas mayores' },
      { label: 'Soluciones integrales',    tooltip: 'Desde tableros eléctricos hasta iluminación LED eficiente y sistemas de respaldo energético' },
    ],
  },
  {
    id: 5,
    icon: icons.maintenance,
    title: 'Mantenimiento Técnico',
    description: 'Tus equipos en las mejores manos. Prolongamos su vida útil para que tu inversión rinda al máximo cada día.',
    features: [
      { label: 'Preventivo y correctivo', tooltip: 'Revisiones programadas y reparaciones inmediatas para mantener tus equipos siempre operativos' },
      { label: 'Reparaciones',            tooltip: 'Solución de fallos de hardware y software con repuestos de calidad y garantía de trabajo' },
      { label: 'Diagnóstico',             tooltip: 'Evaluación técnica detallada para identificar la causa raíz de cualquier falla en tus equipos' },
      { label: 'Soporte técnico',         tooltip: 'Atención especializada presencial y remota para resolver cualquier inconveniente tecnológico' },
    ],
  },
];

const ChevronIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ── Componente tooltip ──
const FeatureTag = ({ label, tooltip }) => {
  const [show, setShow] = useState(false);

  return (
    <span
      className={styles.checkTag}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <span className={styles.checkDot} />
      {label}
      {show && (
        <span className={styles.tooltip}>
          {tooltip}
        </span>
      )}
    </span>
  );
};

const Services = () => {
  const [openId, setOpenId] = useState(1);

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="servicios" className={styles.services}>

      <div className={styles.orbTr} />
      <div className={styles.orbBl} />

      <Container>
        <SectionTitle
          title="Nuestros Servicios"
          subtitle="Soluciones tecnológicas integrales para tu negocio"
          highlight="Servicios"
          light={true}
        />

        <div className={styles.accordion}>
          {servicesData.map((service) => {
            const isOpen = openId === service.id;
            return (
              <div
                key={service.id}
                className={`${styles.accItem} ${isOpen ? styles.open : ''}`}
              >
                <button
                  className={styles.accHeader}
                  onClick={() => handleToggle(service.id)}
                  aria-expanded={isOpen}
                >
                  <span className={styles.accIconWrap}>
                    {service.icon}
                  </span>
                  <span className={styles.accTitle}>{service.title}</span>
                  <span className={`${styles.accArrow} ${isOpen ? styles.accArrowOpen : ''}`}>
                    <ChevronIcon />
                  </span>
                </button>

                <div className={`${styles.accBody} ${isOpen ? styles.accBodyOpen : ''}`}>
                  <div className={styles.accBodyInner}>
                    <p className={styles.accDesc}>{service.description}</p>
                    <div className={styles.checks}>
                      {service.features.map((feature, index) => (
                        <FeatureTag
                          key={index}
                          label={feature.label}
                          tooltip={feature.tooltip}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Services;